import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const EndActivePriceConfirmation = ({ isOpen, onConfirm, onCancel }: IProps) => {
  const { t } = useTranslation();

  return (
    <Confirmation
      isOpen={isOpen}
      title={t('titleEndActivePartPrice')}
      message={t('messageEndActivePartPrice')}
      confirmBtnLabel={t('buttonLabelEnd')}
      confirmBtnColor={Color.SUCCESS}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
